/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

class Phone extends React.Component {
  render() {
    return (
		<svg height="512px" width="512px" version="1.1" viewBox="0 0 485.213 485.212" xmlSpace="preserve" width="30px" height="30px">
			<path className="active-path" d="m242.61 0c-133.98 0-242.61 108.63-242.61 242.61 0 133.98 108.63 242.61 242.61 242.61s242.6-108.63 242.6-242.61c1e-3 -133.98-108.63-242.61-242.6-242.61zm128.11 353.99l-19.425 19.429c-3.468 3.463-13.623 5.624-13.949 5.624-61.452 0.536-120.62-23.602-164.1-67.08-43.593-43.618-67.759-103-67.11-164.66 0-0.028 2.224-9.892 5.689-13.324l19.424-19.427c7.108-7.141 20.762-10.368 30.327-7.168l4.086 1.363c9.537 3.197 19.55 13.742 22.185 23.457l9.771 35.862c2.635 9.743-0.919 23.604-8.025 30.712l-12.97 12.972c12.734 47.142 49.723 84.138 96.873 96.903l12.965-12.975c7.141-7.141 20.997-10.692 30.719-8.061l35.857 9.806c9.717 2.67 20.26 12.62 23.456 22.154l1.363 4.145c3.168 9.538-0.034 23.189-7.141 30.265z" fill=" rgba(var(--ey-spotmentor), 1)"/>
		</svg>
    );
  }
}

export default Phone;



// WEBPACK FOOTER //
// ./src/components/Footer/icons/Phone.js